import axios from 'axios'
const ContentModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH: (state, payload) => {
      state.data = payload
    }
    // DELETE: (state, payload) => {
    //   let index = state.data.findIndex(data => data.idx === payload.idx)
    //   state.data.splice(index, 1)
    // },
    // UPDATE: (state, payload) => {
    //   let index = state.data.findIndex(data => data.idx === payload.idx)
    //   state.data[index] = payload
    // },
    // INSERT: (state, payload) => {
    //   state.data.push(payload)
    // },
    // CREATING: (state, payload) => {
    //   state.isCreating = payload
    // },
    // EDITING: (state, payload) => {
    //   state.isEditing = payload.isEditing
    //   state.formAction = payload.formAction
    //   state.orderId = payload.orderId
    // }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get('/farmerspace/content')
        commit('FETCH', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'There was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    }
    // async insert({ commit, dispatch }, payload) {
    //   try {
    //     const response = await axios.post(`order/insert/${payload.database}`, payload)
    //     dispatch('fetch', payload.database)
    //     commit('INSERT', payload)
    //     return response.data.ordersId
    //   } catch (error) {
    //     throw new Error(error)
    //   }
    // },
    // async update({ commit, dispatch }, payload) {
    //   try {
    //     await axios.put(`order/update/${payload.database}`, payload)
    //     dispatch('fetch', payload.database)
    //     commit('UPDATE', payload)
    //     return true
    //   } catch (error) {
    //     throw new Error(error)
    //   }
    // },
    // async delete({ commit }, payload) {
    //   try {
    //     await axios.delete(
    //       `order/delete/${localStorage.getItem('token')}/${payload.idx}/${payload.database}`
    //     )
    //     commit('DELETE', payload)
    //     return true
    //   } catch (error) {
    //     throw new Error(error)
    //   }
    // }
  },
  getters: {
    getAll: state => {
      return state.data
    }
    // getByOrderId: state => orderid => {
    //   return state.data.filter(item => item.idx === orderid)
    // },
    // getActive: state => {
    //   return state.data.filter(item => item.status === 'active')
    // }
  }
}

export default ContentModule
